<template>
  <div class="container-fluid h-100 centercard pt-4">
    <div class="row justify-content-center align-items-center h-100">
      <div class="col col-sm-10 col-md-10 col-lg-9 col-xl-6">
        <b-card header-tag="header" footer-tag="footer">
          <h4 slot="header" class="mb-0 text-center title">Consulta Web</h4>
          <div class="text-center">
            <img src="/images/logofo2.png" alt="Logo">
          </div>
          <br />
          <div class="text-center">
            <b-button type="reset" @click="backView" variant="danger">
              <i class="fa fa-backward"/> Consulta Nueva
            </b-button>
            <br />
            <template>
              <b-button
                v-if="sendDownload.cdr"
                type="submit"
                @click="downloadCDR()"
                variant="primary"
                :disabled="cdr.xml === null"
                v-b-tooltip.hover.topright="cdr.xml === null ? 'CDR no disponible!' : cdr.descripcion + ' ' + cdr.notas"
              >
                <i class="fa fa-download"/> CDR
              </b-button>
              <b-button v-else variant="secondary">
                <i class="fa fa-spin fa-spinner"></i> Descargando...
              </b-button>
            </template>
            <template>
                <b-button
                  v-if="sendDownload.xml"
                  type="submit"
                  @click="downloadXML()"
                  variant="primary"
                  :disabled="xml === null"
                >
                <i class="fa fa-download"/>
                 XML</b-button>
                <b-button v-else variant="secondary">
                  <i class="fa fa-spin fa-spinner"></i> Descargando...
                </b-button>
              </template>
              <template>
                <b-button
                  v-if="sendDownload.pdf"
                  type="submit"
                  @click="downloadPDF()"
                  variant="primary"
                  :disabled="pdfobject === null"
                >
                  <i class="fa fa-download"/> PDF
                </b-button>
                <b-button v-else variant="secondary">
                  <i class="fa fa-spin fa-spinner"></i> Descargando...
                </b-button>
              </template>
          </div>
          <b-spinner v-if="Loading" variant="primary" label="Cargando..."></b-spinner>
          <template slot="footer" ><div class="copyright float-right">2021 - Desarrollado por: <img src="/images/data_logo.png" alt="Logo Telemovil Data" height="30px"></div></template>
          <template v-if="pdfobject">
            <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
          </template>
          <template v-if="Errors.data">
            <b-card
              header-tag="header"
              footer-tag="footer"
              border-variant="danger" 
              header-border-variant="danger"
              header-text-variant="danger">
              <template #header>
                <b-alert show variant="danger">
                  <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i> {{ Errors.data.msg }}
                </b-alert>
              </template>
              <b-card-text>
                  <b-row>
                    <b-col  cols="5" class="text-right">Emisor: </b-col>
                    <b-col cols="7"> {{ emisor }} </b-col>
                  </b-row>
                  <b-row>
                    <b-col  cols="5" class="text-right">Receptor: </b-col>
                    <b-col cols="7"> {{ receptor }} </b-col>
                  </b-row>
                  <b-row>
                    <b-col  cols="5" class="text-right">Comprobante: </b-col>
                    <b-col cols="7">{{ serie }} - {{ numero }} </b-col>
                  </b-row>
                  <b-row>
                    <b-col  cols="5" class="text-right"> &nbsp; </b-col>
                    <b-col cols="7">
                      {{ Comprobante.find( element => element.tipo === tipo ).descripcion }}
                    </b-col>
                  </b-row>
                  
              </b-card-text>
            </b-card>
          </template>
          <template v-else-if="Errors.message">
            <b-alert show variant="danger">
              <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i> {{ Errors.message }}
            </b-alert>
          </template>
        </b-card>
      </div>
    </div>
  </div>    
</template>
<script>
//import {isBase64} from 'is-base64' 
//import {Base64} from 'js-base64';
import Axios from 'axios'
import download from "downloadjs"
function isBase64(str) {
    try {
        return btoa(atob(str)) === str ? true : false
    } catch(e) {
        return false
    }
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms * 1000));
}

export default {
  name: 'descargaWeb',
  data () {
    return {
      uid : null,
      pkey: null,
      Errors: {},
      Loading: true,
      sendDownload: {
        pdf: true,
        cdr: true,
        xml: true
      },
      cdr: {
        notas : null,
        descripcion: null,
        xml: null
      },
      xml: null,
      pdfobject: null,
      emisor: null,
      receptor: null,
      serie: null,
      numero: null,
      tipo: null,
      importetotal: null,
      Comprobante: [
        {
          tipo: "1",
          codigo: "01",
          descripcion: "Factura Electronica"
        },
        {
          tipo: "2",
          codigo: "03",
          descripcion: "Boleta Electronica"
        },
        {
          tipo: "3",
          codigo: "07",
          descripcion: "Nota de Credito Electronica"
        },
        {
          tipo: "4",
          codigo: "08",
          descripcion: "Nota de Debito Electronica"
        },
        {
          tipo: "5",
          codigo: "09",
          descripcion: "Guia de Remision Remitente Electronica"
        }
      ]
    };
  },
  methods: {
    getContent (uid) {
      let arrayUID = uid.split(".")
      if(arrayUID.length > 1){
          let arrayPkey = arrayUID[0].split("-")
          if(arrayPkey.length > 1){
            this.pkey = arrayPkey[1]
            if(isBase64(arrayUID[1])){
              let decodeData = atob(arrayUID[1])
              let arrayData = decodeData.split("|")
              if(arrayData.length === 6){
                let comprobante = this.Comprobante.find( element => element.codigo === arrayData[1] )
                if(typeof comprobante === 'undefined'){
                  this.Loading = false
                  this.Errors = {"message": "Código de comprobante invalido("+arrayData[1]+")"}
                  return
                }
                this.tipo = comprobante.tipo
                this.emisor = arrayData[0]
                this.serie = arrayData[2]
                this.numero = parseInt(arrayData[3])
                this.receptor = arrayData[4]
                this.importetotal = parseFloat(arrayData[5])
                //this.Errors = null
                this.Loading = true
                Axios
                .post(
                  process.env.VUE_APP_API_URL + "clientes/consulta/" + this.tipo,
                  {
                    serie: this.serie,
                    numero: this.numero,
                    rucreceptor: this.receptor,
                    rucemisor: this.emisor,
                    totalventa: this.importetotal
                  }
                )
                .then(
                  response => {
                    if(response.data.cdr){
                      this.cdr.notas = response.data.cdr.notas
                      this.cdr.descripcion = response.data.cdr.descripcion
                      this.cdr.xml = response.data.cdr.xml
                    }
                    this.xml = response.data.xml
                    this.pdfobject = response.data.base64
                    // console.log(response.data);
                    // (this.descargables = response.data),                    // (this.cdr = response.data.cdr.xml),
                    // (this.envioDatos = true),
                    // (this.documentosDescargados = false)
                    this.Loading = false
                    //this.Errors = {}
                  }
                )
                .catch(error => { // function(error){} sin arrow dentro de llaves el this de data vue no es reconocido.
                  this.Errors = error.response
                    /*
                    (this.envioDatos = true),
                    (this.documentosDescargados = true),
                    this.$snotify.error(
                      "El documento que esta buscando no fue encontrado",
                      "Error"
                    ),*/
                    //console.log(error.response)
                    this.Loading = false
                  }
                );
              }
            
            }else{
              this.Loading = false
              this.Errors = {"message": "Hash de comprobante invalido"}
            }
          }else{
            this.Loading = false
            this.Errors = {"message": "Key de acceso invalido"}
          }
      }else{
            console.log("Now")
            this.Loading = false
            this.Errors = {"message": "URL invalido"}

      }
      //console.log(arrayUID.length)
      this.uid = uid
      //const document = await this.$prismic.client.getByUID('blog_post', uid);
      //this.fields.richContent = document.data.rich_content;
    },
    downloadCDR: async function() {
      this.sendDownload.cdr = false
      await sleep(1)
      let name = "CDR-" + this.serie + "-" +this.numero + ".zip";
      let file = "data:application/zip;base64," + this.cdr.xml;
      (this.sendDownload.cdr = true), download(file, name, "application/zip");
    },
    downloadXML: async function() {
      this.sendDownload.xml = false
      await sleep(1)
      let name = this.serie + "-" + this.numero + ".zip";
      let file = "data:application/zip;base64," + this.xml;
      (this.sendDownload.xml = true), download(file, name, "application/zip");
    },
    downloadPDF: async function() {
      this.sendDownload.pdf = false
      await sleep(1)
      let name = this.serie + "-" + this.numero + ".pdf";
      let file = "data:application/pdf;base64," + this.pdfobject;
      (this.sendDownload.pdf = true), download(file, name, "application/pdf");
    },
    backView: function() {
      this.$router.push({ name: 'consultaWeb' })
      //this.documentosDescargados = true;
    }
  },
  created () {
    this.getContent(this.$route.params.uid);
  },
  beforeRouteUpdate (to, from, next) {
    this.getContent(to.params.uid);
    next();
  }
};
</script>
<style lang="sss" scoped>

</style>